const message = {
  Confirm: "确定",
  Cancel: "取消",
  reset: "重置",
};

export default message;
